<template>
  <v-container fluid tag="section">
    <v-card class="rounded-lg elevation-0">
      <v-tabs v-model="tab" slider-color="primary" :show-arrows='$isMobile'>
        <v-tab>待缴受理费</v-tab>
        <v-tab>待缴授权费</v-tab>
        <v-tab>待缴年费</v-tab>
        <v-tab v-has="'patent-cost-list'">年费记录</v-tab>
        <v-tab>证书/收据</v-tab>
      </v-tabs>
    </v-card>
    <div class="my-3">
      <v-tabs-items v-model="tab">
        <v-tab-item class="grey lighten-4">
          <accept-fee></accept-fee>
        </v-tab-item>
        <v-tab-item class="grey lighten-4">
          <auth-fee></auth-fee>
        </v-tab-item>
        <v-tab-item class="grey lighten-4">
          <annual-fee></annual-fee>
        </v-tab-item>
        <v-tab-item class="grey lighten-4">
          <annual-record></annual-record>
        </v-tab-item>
         <v-tab-item class="grey lighten-4">
          <file-detail></file-detail>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  import AuthFee from './components/AuthFee.vue'
  import AnnualFee from './components/AnnualFee.vue'
  import AnnualRecord from './components/AnnualRecord.vue'
  import AcceptFee from './components/AcceptFee.vue'
  import FileDetail from './components/FileDetail.vue'

  export default {
    name: 'PatentCost',
    components: {
      AuthFee,
      AnnualFee,
      AnnualRecord,
      AcceptFee,
      FileDetail
    },
    data() {
      return {
        tab: ''
      }
    },
    methods: {
    }
  }
</script>

<style lang="sass">
  .system-user-page
</style>
